import React from "react";
import { Link } from "react-router-dom";
import reflections66Banner from "../../assets/images/reflections-66-banner.png";

const DETAIL_PATH =
  "/buy/detail/reflections-66–luxury-apartments-in-whitefield-32";

const ReflectionsPromoBanner = () => {
  return (
    <section className="reflections-promo-banner py-4">
      <div className="container">
        <div className="row g-3 align-items-stretch reflections-promo-row">
          <div className="col-12 col-lg-3 d-flex order-2 order-lg-1">
            <Link to={DETAIL_PATH} className="reflections-info-box">
              <span className="reflections-info-box__badge">Booking Open</span>
              <div className="reflections-info-box__title-wrap">
                <h3>Reflections 66</h3>
                <p className="by-line">
                  By <span className="brand-name">House of Colors</span>
                </p>
                <p className="location-line">At Whitefield, Bangalore</p>
              </div>
              <div className="reflections-info-box__features">
                <ul>
                  <li>66 Boutique Condos</li>
                  <li>Rooftop Amenities</li>
                  <li>IGBC Platinum Pre-Certified</li>
                </ul>
              </div>
              <div className="reflections-info-box__price-wrap">
                <p className="price-label">Luxury 1, 2 & 3 BHK Residences</p>
                <p className="price-value">Starts at 96.60L*</p>
                <span className="enquire-btn">Enquire Now</span>
              </div>
            </Link>
          </div>
          <div className="col-12 col-lg-9 d-flex order-1 order-lg-2">
            <Link to={DETAIL_PATH} className="promo-box-item">
              <img
                src={reflections66Banner}
                alt="Reflections 66 by House of Colors - Luxury apartments in Whitefield"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReflectionsPromoBanner;
